import { render } from "./selecionarDisciplinasProfessor.vue?vue&type=template&id=fe23e556&scoped=true"
import script from "./selecionarDisciplinasProfessor.vue?vue&type=script&lang=js"
export * from "./selecionarDisciplinasProfessor.vue?vue&type=script&lang=js"

import "./selecionarDisciplinasProfessor.vue?vue&type=style&index=0&id=fe23e556&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe23e556"]])

export default __exports__